import React from "react";
import styled from "styled-components";

export default function Faq() {
  return (
    <StyledFaq className="faq_section">
      <div className="container">
        <h2 className="section_title">Вопросы и ответы</h2>
        <div className="faq_row">
          <div className="faq_column">
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
          </div>
          <div className="faq_column">
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
            <div className="faq_item">
              <h3 className="faq_item_title">Что такое Мы?</h3>
              <div className="faq_item_text">
                Это полностью бесплатная платформа для изучения основ
                программирования с нуля. Мы был создан разработчиками и
                сообществом Мы для того, чтобы любой желающий мог попробовать
                себя в программировании и заложить правильный фундамент для
                новой профессии, основанный не на запоминании специфики, а на
                понимании системы в целом.
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledFaq>
  );
}

const StyledFaq = styled.div`
  &.faq_section {
    margin-top: 96px;
  }
  .faq_row {
    margin-top: 48px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 24px;
  }
  .faq_item_title {
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  .faq_item_text {
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  @media (max-width: 567px) {
    .faq_row {
      grid-template-columns: 1fr;
    }
  }
`;
